import { render, staticRenderFns } from "./RoundBottomFlaskSvg.vue?vue&type=template&id=3a84be7f&"
import script from "./RoundBottomFlaskSvg.vue?vue&type=script&lang=ts&"
export * from "./RoundBottomFlaskSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3a84be7f', component.options)
    } else {
      api.reload('3a84be7f', component.options)
    }
    module.hot.accept("./RoundBottomFlaskSvg.vue?vue&type=template&id=3a84be7f&", function () {
      api.rerender('3a84be7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/RoundBottomFlaskSvg.vue"
export default component.exports